import * as React from 'react'
// libs
import { Link, useNavigate } from 'react-router-dom'
// hooks
import {
  Themes,
  THEME_KEY,
  HIDE_CONTACT_HEADER_KEY,
} from '../../../hooks/useTheme'
// styles
import s from './styles.module.css'

const LearnMoreButton = ({ customLabel }) => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate('/contact')
    localStorage.setItem(THEME_KEY, Themes.LIGHT)
    localStorage.setItem(HIDE_CONTACT_HEADER_KEY, 'true')
  }

  return (
    <Link to='/contact' onClick={onClick} className={s.button}>
      {customLabel || 'Learn More'}
    </Link>
  )
}

export default LearnMoreButton
